// THE THREE COLUMNS AN EXPENSE ROW IS READ BY, shared by every expense table (the job
// panel and the expense overview) so they cannot drift: what we asked the client for,
// what it cost us, and who bears it in the end. Right to left, in that order, after the
// category and description. Display only — every figure is the server's.
import he from '../i18n/he';
import { Cost } from './Money';
import AskedCell from './AskedCell';
import BearerCell from './BearerCell';

export const expenseAmountColumns = [
  { key: 'asked', label: he.expenses.askedColumn, className: 'num', render: (r) => <AskedCell expense={r} /> },
  {
    key: 'amount',
    label: he.jobs.amount,
    className: 'num',
    render: (r) => <Cost value={r.amount} className="amount-strong" />,
  },
  // WHO BEARS IT, with the state of its charge. "לא צוין" for a row recorded before the
  // question was asked, which must never read as "we absorb it".
  { key: 'borne_by', label: he.expenses.borneByShort, render: (r) => <BearerCell expense={r} /> },
];
